import styled from 'styled-components'

export const Root = styled.div`
  margin-bottom: ${(props) => props.theme.margin.big};
`
